import { Timestamp } from '@britishcouncil/common-core';
import {
  CentreTypeSelector,
  api,
  DisciplinaryActionDueReportRecordDto,
  PagedResultOfDisciplinaryActionDueReportRecordDto,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { DisciplinaryActionDueReportFilterType } from './disciplinaryActionDueReportTypes';
import {
  getBcCentresIds,
  getIdpCentresIds,
  getPaginationParameters,
  getQueryStringParameters,
} from 'utils';

type ReportParams = TableState<
  DisciplinaryActionDueReportRecordDto,
  DisciplinaryActionDueReportFilterType
>;
const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      from: Timestamp.toISOString(params.filters.date[0]),
      to: Timestamp.toISOString(params.filters.date[1]),
      warningTypes: params.filters.warningTypes ?? [],
      regionsIds: params.filters.regionsIds ?? [],
      countriesIds: params.filters.countriesIds ?? [],
      centresIds: getBcCentresIds(params.filters.centresIds),
      idpCentresIds: getIdpCentresIds(params.filters.centresIds),
      centreType: params.filters.centreType ?? CentreTypeSelector.ALL,
    },
  };
};

export const disciplinaryActionDueReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getDisciplinaryActionDueRecords: builder.query<
      PagedResultOfDisciplinaryActionDueReportRecordDto,
      ReportParams
    >({
      query: (params) => {
        const input = mapQueryParams(params);
        return api.disciplinaryActionDueReport.getDisciplinaryActionDueReport(input);
      },
    }),
    generateDisciplinaryActionDuePdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.disciplinaryActionDueReport.getDisciplinaryActionDuePdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateDisciplinaryActionDueExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.disciplinaryActionDueReport.getDisciplinaryActionDueExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetDisciplinaryActionDueRecordsQuery,
  useGenerateDisciplinaryActionDuePdfReportMutation,
  useGenerateDisciplinaryActionDueExcelReportMutation,
} = disciplinaryActionDueReportApi;
